class ProductGalleryCustom extends Carousel {
  constructor() {
    console.log('ARIJIT TESTING >>>>>>>>>>');
    
    super();
    this.paneContainer = document.querySelector('.zoom-in-feature');
    this.paneContainer.style.display = "none";

    // Only for desktop
    if (window.innerWidth > 750) {
      this.initiateZoom();
    }

    this.variantFilter = this.carouselElement.dataset['variantfilter'] === 'true' || false;

    this.observeHeaderVisibility();
    this.updateZoomPaneDimensions();
    window.addEventListener("resize", () => this.updateZoomPaneDimensions());
  }

  updateZoomPaneDimensions() {
    const announcementBar = document.querySelector('.announcement-bar ');
    const header = document.querySelector('.shopify-section--header');
    const buyButtons = document.querySelector('.product-info__buy-buttons--sticky');

    const getHeight = (element) => (element && element.offsetHeight) || 0;

    const isHeaderHidden = header && (getComputedStyle(header).visibility === 'hidden' || header.offsetHeight === 0);

    let topOffset = getHeight(announcementBar) + (isHeaderHidden ? 0 : getHeight(header));
    let totalExcludedHeight = topOffset + getHeight(buyButtons) + 10;

    // Set height and top position dynamically
    this.paneContainer.style.top = `${topOffset + 10 }px`;
    this.paneContainer.style.height = `calc(100vh - ${totalExcludedHeight + 10}px)`;
  }

  initiateZoom() {
    if (!Drift) return;

    const driftImgs = this.carouselElement.querySelectorAll('.main-product-gallery img');
    const paneContainer = this.paneContainer;

    driftImgs.forEach(img => {
      new Drift(img, {
        zoomFactor: 2.2,
        paneContainer: paneContainer,
        inlinePane: false,
        hoverBoundingBox: true,
        showWhitespaceAtEdges: true,
      });

      // Show zoom pane & change cursor on hover
      img.addEventListener("mouseenter", () => {
        paneContainer.style.display = "block";
        img.style.cursor = "crosshair";
      });

      img.addEventListener("mouseleave", () => {
        paneContainer.style.display = "none";
        img.style.cursor = "default"; // Revert cursor to normal
      });
    });
  }

  observeHeaderVisibility() {
    const header = document.querySelector('.shopify-section--header');
    if (!header) return;

    const paneContainer = this.paneContainer;

    const checkVisibility = () => {
      const isHidden = getComputedStyle(header).visibility === 'hidden' || header.offsetHeight === 0;

      if (isHidden) {
        paneContainer.classList.add('header-hidden');
      } else {
        paneContainer.classList.remove('header-hidden');
      }

      this.updateZoomPaneDimensions(); // Update top position and height when header visibility changes
    };

    // Check on load
    checkVisibility();

    // Observer to track class and style changes
    const observer = new MutationObserver(() => {
      checkVisibility();
    });

    observer.observe(header, { attributes: true, attributeFilter: ['style', 'class'] });

    // Fallback: Periodic check in case of undetected changes
    setInterval(checkVisibility, 500);
  }

  showAllMedia() {
    let allItems = this.carouselElement.querySelectorAll('[data-filter]');
    let allThumbnailItems = this.syncElement.querySelectorAll('[data-filter]');

    allItems.forEach(element => {
      element.classList.add('splide__slide');
      element.classList.remove('hidden');
    });

    allThumbnailItems.forEach(element => {
      element.classList.add('splide__slide');
      element.classList.remove('hidden');
    });

    this.refreshSlider();
  }

  filterMedia(media) {
    this.showAllMedia();

    let filterSlides = this.carouselElement.querySelectorAll(`[data-filter]:not([data-filter="${media?.alt}"])`);
    let filterSlidesThumbnails = this.syncElement.querySelectorAll(`[data-filter]:not([data-filter="${media?.alt}"])`);

    filterSlides.forEach(element => {
      element.classList.remove('splide__slide');
      element.classList.add('hidden');
    });

    filterSlidesThumbnails.forEach(element => {
      element.classList.remove('splide__slide');
      element.classList.add('hidden');
    });

    this.refreshSlider();
  }

  setActiveMedia(media) {
    if (this.variantFilter && media?.alt) {
      this.filterMedia(media);
    }

    let Slides = this.carousel.Components.Slides.filter(`li[data-media-id="${media?.id}"]:not(.splide__slide--clone)`);
    if (Slides[0]) {
      this.refreshSlider();
      this.carousel.go(Slides[0].index);
    }
  }
}

customElements.define('product-gallery-custom', ProductGalleryCustom);
